var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lenderResponses.length
    ? _c("v-client-table", {
        staticClass: "w-100 vue-custom-table no-pagination text-center",
        attrs: {
          data: _vm.lenderResponses,
          columns: _vm.tableColumns,
          options: _vm.options,
          name: "consentRequestsTable",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "date",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("div", { staticClass: "column" }, [
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("formatDate")(row.createdAt)) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0 small" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("formatDateTimezone")(row.createdAt)) +
                          "\n      "
                      ),
                    ]),
                  ]),
                ]
              },
            },
            {
              key: "lender",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "capitalize mb-0" }, [
                    _vm._v("\n      " + _vm._s(row.lenderName) + "\n    "),
                  ]),
                ]
              },
            },
            {
              key: "mortgageType",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "capitalize mb-0" }, [
                    _vm._v("\n      " + _vm._s(row.mortgageType) + "\n    "),
                  ]),
                ]
              },
            },
            {
              key: "expiryDate",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("formatDate")(
                            row.lenderResponse.responseDetails
                              .commitmentExpiryDate
                          )
                        ) +
                        "\n    "
                    ),
                  ]),
                ]
              },
            },
            {
              key: "responseType",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip",
                          value: {
                            title: _vm.$t(
                              "global.messages.clickHereForMoreDetails"
                            ),
                            placement: "top",
                            disabled: !_vm.isDeclined(row.status),
                          },
                          expression:
                            "{\n        title: $t('global.messages.clickHereForMoreDetails'),\n        placement: 'top',\n        disabled: !isDeclined(row.status)\n      }",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.showDetailsFocusedSection(row)
                        },
                      },
                    },
                    [
                      _c("submission-status-badge", {
                        attrs: { status: row.status },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "responseDate",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("div", { staticClass: "column" }, [
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("formatDate")(row.responseAt)) +
                          "\n      "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0 small" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm._f("formatDateTimezone")(row.responseAt)) +
                          "\n      "
                      ),
                    ]),
                  ]),
                ]
              },
            },
            {
              key: "actions",
              fn: function (ref) {
                var row = ref.row
                var index = ref.index
                return [
                  _c("action-buttons", {
                    ref: "actionButtons-" + index,
                    attrs: {
                      "mpp-disabled": _vm.mppDisabled,
                      status: row.status,
                      "mpp-available": _vm.isMppAvailable(row),
                      "mpp-doc-available": _vm.isMppDocAvailable(row),
                      "mpp-failed": _vm.mppFailed(row),
                      "mpp-messages": _vm.mppMessages(row),
                      "generating-mpp": _vm.generatingMpp,
                      "access-rights": _vm.accessRights,
                    },
                    on: {
                      accept: function ($event) {
                        return _vm.handleClick(row, index, "accept")
                      },
                      details: function ($event) {
                        return _vm.handleClick(row, index, "details")
                      },
                      preview: function ($event) {
                        return _vm.handleClick(row, index, "preview")
                      },
                      "download-mpp": function ($event) {
                        return _vm.handleClick(row, index, "download-mpp")
                      },
                      "generate-mpp": function ($event) {
                        return _vm.handleClick(row, index, "generate-mpp")
                      },
                    },
                  }),
                ]
              },
            },
          ],
          null,
          false,
          3856029088
        ),
      })
    : _c(
        "div",
        { staticClass: "row justify-content-center align-items-center" },
        [
          _c(
            "no-results",
            {
              attrs: {
                "img-src": require("@Shared/@Assets/img/application-missing.png"),
              },
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t("direct-to-lender.lenderSubmit.emptySubmissions")
                  ) +
                  "\n  "
              ),
            ]
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }